if (!customElements.get("sht-carousel-wrapper")) {
    class SHTCarouselWrapper extends HTMLElement {
      constructor() {
        super();
        this.carousels = this.querySelectorAll(".js-carousel-item");
        this.container = this.querySelectorAll(".js-carousel-items");
        this.onlyEnableMobile = this.dataset.onMobileOnly || "false";
        if (this.onlyEnableMobile == "true") {
          this.prepare();
        }
      }
      prepare() {
        let cssContainerClass = this.dataset.cssClassOnContainer.split(" ");
        let cssItemClass = this.dataset.cssClassOnItem.split(" ");
  
        if (!window.matchMedia("(max-width: 459px)").matches) {
          this.toggleClass(this.container, cssContainerClass, false);
          this.toggleClass(this.carousels, cssItemClass, false);
          this.setCarouselVisibility(this.carousels, "-1");
        } else {
          this.toggleClass(this.container, cssContainerClass, true);
          this.toggleClass(this.carousels, cssItemClass, true);
          this.setCarouselVisibility(this.carousels, "0");
        }
  
        let resizeObserver = new ResizeObserver((entries) => {
          if (!window.matchMedia("(max-width: 459px)").matches) {
            this.toggleClass(this.container, cssContainerClass, false);
            this.toggleClass(this.carousels, cssItemClass, false);
            this.setCarouselVisibility(this.carousels, "-1");
          } else {
            this.toggleClass(this.container, cssContainerClass, true);
            this.toggleClass(this.carousels, cssItemClass, true);
            this.setCarouselVisibility(this.carousels, "0");
          }
        });
        resizeObserver.observe(document.body);
      }
  
      toggleClass(target, className, toggle) {
        if (toggle) {
          target.forEach((e) => {
            e.classList.add(...className);
            e.setAttribute("tabindex", "0");
          });
        }
  
        if (!toggle) {
          target.forEach((e) => {
            e.classList.remove(...className);
            e.setAttribute("tabindex", "-1");
          });
        }
      }
  
      setCarouselVisibility(target, flag) {
        target.forEach((e) => {
          e.setAttribute("tabindex", `${flag}`);
        });
      }
    }
  
    customElements.define("sht-carousel-wrapper", SHTCarouselWrapper);
  }
  